<div class="container-fluid">
	<div class="row align-items-center my-3 mx-0">
		<div class="col">
			<h1>Clientes para {{ecommerce.name }}</h1>
		</div>

		<div class="col-auto">
			<a class="btn btn-secondary lift" (click)="show_add_user = true">
				<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1.3em" height="1.3em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M4.5 8.552c0 1.995 1.505 3.5 3.5 3.5s3.5-1.505 3.5-3.5s-1.505-3.5-3.5-3.5s-3.5 1.505-3.5 3.5zM19 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM4 19h10v-1c0-2.757-2.243-5-5-5H7c-2.757 0-5 2.243-5 5v1h2z" fill="currentColor"/></svg>
				Agregar
			</a>
			<a class="btn btn-info lift ms-2" [href]="rest.external_app_url + '/list-ecommerce-profile/' + ecommerce.id">
				<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1.3em" height="1.3em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.29-6-3.22c.03-1.99 4-3.08 6-3.08s5.97 1.09 6 3.08c-1.29 1.93-3.5 3.22-6 3.22z" fill="currentColor"/></svg>
				Perfiles
			</a>
		</div>
	</div>

	<!--form (submit)="search(user_search)" name="search_client">
		<div class="p-3 card my-3">
			<div class="row">
				<div class="col-8 col-md-5 form-group">
					<label class="">Nombre</label>
					<input type="text" name="name" [(ngModel)]="user_search.lk.name" class="form-control">
				</div>
				<div class="col-6 col-md-2 form-group">
					<label class="">&nbsp;</label>
					<button type="submit" class="w-100 btn btn-primary">Buscar</button>
				</div>
			</div>
		</div>
	</form-->
	<div class="card p-3 mt-3">
		<app-loading [is_loading]="is_loading"></app-loading>
		<div class="table-responsive">
			<table class="table table-sm table-nowrap mb-0">
				<thead class="thead-light">
					<tr>
						<th class="">Usuario</th>
						<th class="">Tipo</th>
						<th class="text-end pointer">Actualizado</th>
						<th class="text-end">Acciones</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let ecommerce_user_info of ecommerce_user_info_list">
						<td>
							<img *ngIf="ecommerce_user_info.user.image_id" [src]="rest.getImagePath(ecommerce_user_info.user.image_id)" style="max-width:30px;max-height:30px;">
							<span *ngIf="!ecommerce_user_info.user.image_id" class="default_image">
								<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="2em" height="2em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path _ngcontent-tvn-c138="" d="M12 2C6.579 2 2 6.579 2 12s4.579 10 10 10s10-4.579 10-10S17.421 2 12 2zm0 5c1.727 0 3 1.272 3 3s-1.273 3-3 3c-1.726 0-3-1.272-3-3s1.274-3 3-3zm-5.106 9.772c.897-1.32 2.393-2.2 4.106-2.2h2c1.714 0 3.209.88 4.106 2.2C15.828 18.14 14.015 19 12 19s-3.828-.86-5.106-2.228z" fill="currentColor"></path></svg>
							</span>
							&nbsp;
							{{ecommerce_user_info.user.name}}
						</td>
						<td>{{ecommerce_user_info.type}}</td>
						<td>{{ecommerce_user_info.user.updated | shortDate }}</td>
						<td class="text-end">
							<ng-container *ngIf="rest.current_permission.reports">
								<a [routerLink]="['/list-cash-close',ecommerce_user_info.user.id]" class="btn btn-primary">Ordenes</a>
							</ng-container>
							<!--button (click)="deleteUser(ecommerce_user_info)" class="ms-1 btn btn-danger" *ngIf="rest.current_permission.add_user">Eliminar</button-->
						</td>
					</tr>
					<tr *ngIf="ecommerce_user_info_list.length == 0 && !is_loading">
						<td colspan="2">
							<div class="alert alert-light m-3" role="alert">No se encontraron elementos</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
	<app-pagination [path]="'/list-user'" [pages]="pages" [total_pages]="total_pages" [current_page]="current_page"></app-pagination>
</div>

<app-modal [show]="show_add_user">
	<div class="card">
		<div class="card-body">
			<h3 class="card-title">Registrar Nuevo Usuario</h3>
			<form id="addUserForm" (submit)="addUser($event)" ngNativeValidate>
				<div class="row g-3">
					<div class="col-md-12">
						<label class="form-label">Nombre Completo</label>
						<input type="text" class="form-control" name="name" [(ngModel)]="new_user.name" required>
					</div>
					<div class="col-md-6">
						<label class="form-label">Usuario</label>
						<input type="text" class="form-control" name="user[username]" [(ngModel)]="new_user.username" required>
					</div>
					<div class="col-md-6">
						<label class="form-label">Contraseña</label>
						<input type="password" class="form-control" name="user[password]" [(ngModel)]="new_user.password">
					</div>
					<div class="col-md-6">
						<label class="form-label">Role</label>
						<select class="form-control" name="role_id" [(ngModel)]="new_user.role_id">
							<option value="">Sin Role</option>
							<option *ngFor="let role of roles" [value]="role.id">{{role.name}}</option>
						</select>
					</div>
					<div class="col-md-6">
						<label class="form-label">Tipo</label>
						<select class="form-control" name="type" [(ngModel)]="new_ecommerce_user_info.type">
							<option value="ROLE_USER">Usuario</option>
							<option value="ROLE_ADMIN">Admin</option>
							<option value="ECOMMERCE_ADMIN">Ecommerce Admin</option>
						</select>
					</div>
					<div class="col-md-12">
						<button type="submit" class="btn btn-success" [disabled]="is_loading">Registrar Usuario</button>
						<button type="button" class="btn btn-secondary ms-2" (click)="show_add_user = false" [disabled]="is_loading">Cancelar</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</app-modal>
